<template>
  <div>
    <L1 class="babyCelender">
      <div class="calenderBaby">
        <div class="calenderbox"><vc-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        disable-page-swipe
        is-expanded
        @update:to-page="cenlendar=$event"
      >
      <template v-slot:day-content="{ day, attributes }">
        <div class="dayCube" @click="fnSelected(day.id)" :class="[
        selected===day.id?'selected': '',
        getDisabled(day.id),
        moment(day.id).isBefore(moment().startOf('day'))?'pass': '',
        moment(day.id).isAfter(moment().endOf('day'))?'comming': ''
        ]">
          <span :class="holidays.includes(day.id)?'is-holiday':''">{{day.day}}</span>
          <template v-if="getDisabled(day.id)!=='disabled'">
            <div class="full" v-if="getClosed(day.id)">滿</div>
          </template>
          <div
          v-for="(attr, a) in attributes"
          @click="getSelectInfo(attr.customData.id)"
          :class="attr.customData.class"
          :key="a" v-html="attr.customData.title"></div>
        </div>
      </template>
      </vc-calendar></div>
      <div class="daily">
      <div class="dailyStatus2"></div>
      <div class="dailyStatus">
        <div class="icon"></div>
        <div v-if="selected">
          <div class="datetime">{{toDate(selected)}}<br>{{toWeekday(selected)}}</div>
          <div class="contentSelected">
            <div class="alldisabled">
              <div>今日活動預約</div><input type="checkbox" v-model="itemSelect.disabled" @change="updatedisabled(selected, $event.target.checked)">
            </div>
            <hr  class="hrdeco">
            <div class="table">
              <div v-for="(wd, w) in itemSelect.options" :key="`wd-${w}`" class="tr">
                <div class="td"><div>{{wd.time}}</div></div>
                <div class="td"><div :class="wd.closed===false&&'selected'" @click="set(selected, wd.time, false)">可預約</div></div>
                <div class="td"><div :class="wd.closed===true&&'selected'" @click="set(selected, wd.time, true)">額滿</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </L1>
    <infoSlider :style="{zIndex: 100}" :printBtn="false" :show="!!info" @close="info=null" label="預約資訊" :icon="'baby'" :width="481" @printInfo="printInfo=true">
      <baby-info :salesmans="salesmans" @updateItem="updateItem" :itemSelect="info" @close="info=null"/>
    </infoSlider>
  </div>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import babyInfo from './BabyInfo.vue'
import infoSlider from '../../components/infoSlider_v2.vue'
import { getapi, postapi } from '../../store/fetch'
const wdy = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']

export default {
  components: { babyInfo, L1, infoSlider },
  data () {
    return {
      masks: {
        weekdays: 'WWW'
      },
      cenlendar: {
        month: this.moment().month(),
        year: this.moment().year()
      },
      attributes: [
      ],
      holidays: [],
      selected: null,
      bookstatus: [],
      salesmans: [],
      babyTimeHoliday: [],
      babyTimeWeekday: [],
      itemSelect: null,
      info: null,
      babyStatus: [],
      range: {
        start: null,
        end: null
      }
    }
  },
  watch: {
    cenlendar () {
      this.updateStatus()
    },
    selected () {
      if (this.selected) {
        this.updateItemSelect()
      }
    }
  },
  async mounted () {
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
    this.babyBookableWeekday = await getapi('selections/babyBookableWeekday')
    this.babyBookableHoliday = await getapi('selections/babyBookableHoliday')
    this.babyStatus = await getapi('babyStatus')
    this.babyTimeWeekday = await getapi('selections/babyTimeWeekday')
    this.babyTimeHoliday = await getapi('selections/babyTimeHoliday')
    const range = await getapi('selections/babyDateRange')
    this.range = {
      start: this.toDate(range.start),
      end: this.toDate(range.end)
    }
    this.getHoliday()
    this.updateStatus()
  },
  methods: {
    updateItem () {

    },
    async getSelectInfo (id) {
      const info = await getapi(`babybirthday/${id}`)

      this.info = {
        ...info,
        visitDateFormatted: this.moment(info.visitDate).format('YYYY-MM-DD')
      }
    },
    async updateItemSelect () {
      const data = this.bookstatus.find(e => this.toDate(e._id) === this.selected)
      const isHoliday = this.holidays.includes(this.toDate(this.selected))
      const wd = this.moment(this.selected).weekday()
      const isWeekend = wd === 0 || wd === 6 || wd === 7
      const options = (isHoliday || isWeekend) ? this.babyTimeHoliday : this.babyTimeWeekday
      const closed = this.babyStatus.find(e => this.toDate(e.date) === this.selected)

      this.itemSelect = {
        isHoliday: isHoliday || isWeekend,
        options: options.map(e => {
          return {
            time: e,
            closed: closed ? closed.closed.includes(e) : false
          }
        }),
        disabled: closed && closed.disabled ? closed.disabled : false,
        data: data
      }
    },
    update (k, e) {
      this[k] = e
    },
    async updatedisabled (date, b) {
      // console.log(this.moment(date).startOf('day').toISOString(), b, 'updatedisabled')
      await postapi('babyStatus', {
        date: this.moment(date).startOf('day').toISOString(),
        data: { disabled: b }
      })
      this.itemSelect.disabled = b
      this.babyStatus = await getapi('babyStatus?' + new URLSearchParams(this.cenlendar))
    },
    async set (date, time, b) {
      await postapi(`babyStatus/${b ? 'push' : 'pull'}`, {
        date: this.moment(date).startOf('day').toDate(),
        time: time
      })
      this.babyStatus = await getapi('babyStatus?' + new URLSearchParams(this.cenlendar))
      // console.log('set', date, time, b)
      this.updateItemSelect()
    },
    getClosed (date) {
      const isHoliday = this.holidays.includes(this.toDate(date))
      const isWeekend = this.moment(date).weekday() === 0 || this.moment(date).weekday() === 6 || this.moment(date).weekday() === 7
      const x = this.babyStatus.find(e => this.toDate(e.date) === date)
      const c = (isHoliday || isWeekend) ? this.babyTimeHoliday : this.babyTimeWeekday
      const c2 = x ? x.closed : []
      // console.log(date, (isHoliday || isWeekend), c, c2)
      return c2.filter(e => c.includes(e)).length === c.length
    },
    async updateStatus () {
      const day1 = this.moment().set('year', this.cenlendar.year).set('month', this.cenlendar.month - 1).set('date', 1).startOf('month')
      const daylast = this.moment(day1.format('yyyy-MM-DD')).endOf('month')
      // console.log(day1.format('yyyy-MM-DD'), daylast.format('yyyy-MM-DD'), daylast.diff(day1, 'day'))
      const bookstatus = await getapi('babybirthday?' + new URLSearchParams({
        date: day1.toISOString(),
        duration: daylast.diff(day1, 'day') + 1
      }))
      this.bookstatus = [...bookstatus.data]
      this.attributes = []
      this.babyStatus = await getapi('babyStatus?' + new URLSearchParams(this.cenlendar))
      this.bookstatus.forEach(e => {
        const isHoliday = this.holidays.includes(this.toDate(e._id))
        const isWeekend = this.moment(e._id).weekday() === 0 || this.moment(e._id).weekday() === 6 || this.moment(e._id).weekday() === 7
        // console.log(e._id, this.moment(e._id).weekday())
        this.attributes.push({
          customData: {
            id: e._id,
            title: `
            <div>${e.visitTime}</div><div>${e.orderer}</div>`,
            class: 'parents' + (isHoliday ? ' isHoliday' : '') + (isWeekend ? ' isHoliday' : '') + (e.status ? ` ${e.status}` : '')
          },
          dates: this.moment(e.visitDate).toDate()
        })
      })
    },
    getDisabled (dt) {
      const isHoliday = this.holidays.includes(this.toDate(dt))
      const isWeekend = this.moment(dt).weekday() === 0 || this.moment(dt).weekday() === 6
      if ((isHoliday || isWeekend) && this.babyBookableHoliday) {
        const data = this.babyStatus.find(e => this.toDate(e.date) === dt)
        if (data && data.disabled) {
          return 'disabled'
        } else {
          return ''
        }
      } else if ((!isHoliday && !isWeekend) && this.babyBookableWeekday) {
        const data = this.babyStatus.find(e => this.toDate(e.date) === dt)
        if (data && data.disabled) {
          return 'disabled'
        } else {
          return ''
        }
      } else {
        return 'disabled'
      }
    },
    toWeekday (date) {
      return wdy[this.moment(date).weekday()]
    },
    fnSelected (id) {
      this.selected = id
    },
    async getHoliday () {
      const holidays = await getapi('holidays')
      this.holidays = holidays.map(e => this.moment(e.date).format('YYYY-MM-DD'))
      // console.log(this.holidays.includes('2022-05-02'))
    }
  }
}
</script>
<style lang="scss">
.babyCelender {
  .infoCol > .status {
    font-weight: bold;
    &.預約中 {
      font-size: x-large;
      color: var(--預約中);
    }
    &.已確認 {
      font-size: x-large;
      color: var(--已確認);
    }
    &.已付訂 {
      font-size: x-large;
      color: var(--已付訂);
    }
    &.通知付訂 {
      font-size: x-large;
      color: var(--通知付訂);
    }
    &.已報到 {
      font-size: x-large;
      color: var(--已報到);
    }
    &.已取消 {
      font-size: x-large;
      color: var(--已取消);
    }
  }
  .word4icon {
    background-image: url(/baby.svg)!important;
    background-position: 11.5px 13px;
  }
}
.calenderBaby {
  .parents {
    width: 100%;
    text-align: center;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    border-bottom: 1px solid #FFFFFF;
    &.已報到 {
      background-color: var(--已報到);
      color: #FFFFFF;
    }
    &.預約中 {
      background-color: var(--預約中);
      color: #FFFFFF;
    }
    &.已確認 {
      background-color: var(--已確認);
      color: #FFFFFF;
    }
    &.已付訂 {
      background-color: var(--已付訂);
      color: #FFFFFF;
    }
    &.通知付訂 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
    &.已完成 {
      background-color: var(--已完成);
      color: #FFFFFF;
    }
    &.已取消 {
      background-color: var(--已取消);
      color: #FFFFFF;
      display: none;
    }
  }
  .custom-calendar {
    border: none;
  }
  .vc-arrows-container {
    top: 5px;
    padding-inline: 360px;
  }
  .vc-header {
    height: 55px;
    padding: 10px 18px 10px 18px;
  }
  .vc-arrow {
    color: var(--color-checked);
  }
  .vc-title {
    color: var(--color-checked);
    font-size: 24px;
    padding: 10px 18px 10px 18px;
  }
  .full {
    width: 64px;
    height: 64px;
    background: var(--color-confirm);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    margin-inline: auto;
    margin-top: 10px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    color: #FFFFFF;
  }
  .vc-weekday {
    color: #FFFFFF;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
  }
  .vc-weeks {
    border-radius: 5px;
    background-color: var(--color-checked);
    gap: 1px;
  }
  .vc-day {
    width: 100%;
    box-sizing: border-box;
    min-height: 160px;
    height: auto;
    background-color: #FFFFFF;
  }
.hrdeco {
  height: 12px;
  width: 100%;
  background-color: var(--color-checked);
  mask-image: url(/hrdeco.svg);
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
  border: none;
  margin-block: 20px;
}
.table {
  display: flex;
  margin-inline: 30px;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.tr {
  width: 335px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 20px;
  padding-inline: 20px;
  height: 40px!important;
  .td {
    display: table-cell;
    height: 40px!important;
    box-sizing: border-box;
    &:nth-child(1)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      width: 100px;
      height: 40px;
      border: 1.5px solid var(--color-checked);
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div, &:nth-child(3)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.1em;
      color: #FFFFFF;
      width: 71px;
      height: 40px;
      background-color: #DADADA;
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div.selected {
      background-color: var(--color-tab);
    }
    &:nth-child(3) >div.selected {
      background-color: var(--color-confirm);
    }
  }
}
.tr2 {
  display: grid;
  height: 40px!important;
  grid-template-columns: 100px 71px 71px;
  gap: 20px;
  border-bottom: 1.5px solid var(--color-checked);
  .td {
    display: table-cell;
    height: 40px!important;
    box-sizing: border-box;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    &:nth-child(1)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      letter-spacing: 0.1em;
      color: var(--color-checked);
      width: 100px;
      height: 40px;
      // border: 1.5px solid var(--color-checked);
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2) >div, &:nth-child(3)>div {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      letter-spacing: 0.1em;
      width: 71px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &:nth-child(2)>div::before {
      content: '大';
      font-size: 16px;
      margin-right: 6px;
    }
    &:nth-child(3)>div::before {
      content: '孩';
      font-size: 16px;
      margin-right: 6px;
    }
  }
}
&>.dayCube>span:nth-child(1) {
    font-weight: 500;
  }
.weekday-1, .weekday-7 {
  &>.dayCube>span:nth-child(1) {
    font-weight: 900;
  }
}
.in-next-month, .in-prev-month {
  background-color: #FFFFFFDD;
}
}
</style>
<style lang="scss" scoped>
.calenderBaby {
  padding: 25px 37px;
  display: grid;
  grid-template-columns:  1fr 380px;
  gap: 47px;
}
.contentSelected {
  color: var(--color-letter);
  z-index: 5;
  position: relative;
  padding: 16px;
  padding-top: 35px;
  .alldisabled {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 282px;
    margin: auto;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: var(--color-letter);

  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
    background-color: #85CA9E;
    &:checked {
      background-color: #E37878;
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      right: 2px;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      left: 2px;
    }
  }
}
.datetime {
  width: 100%;
  color: var(--color-checked);
  position: relative;
  z-index: 5;
  padding-top: 47px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35px;
  text-align: center;
  letter-spacing: 0.1em;
}
.icon {
  width: 71px;
  height: 71px;
  background-image: url(/celender.svg);
  border-radius: 50%;
  background-color: var(--color-checked);
  z-index: 5;
  position: absolute;
  top: -35.5px;
  left: 50%;
  transform: translateX(-50%);
}
.daily {
  position: relative;
  z-index: 1;
}
.dailyStatus2 {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin-top: 45px;
  width: 380px;
  height: calc(100% - 45px);
  border-radius: 10px;
  background-color: transparent;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: transparent;
    z-index: -1;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  }
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.dailyStatus {
  z-index: 3;
  margin-top: 45px;
  width: 380px;
  height: calc(100% - 45px);
  z-index: 3;
  position: relative;
  border-radius: 10px;
  &::before {
    content: '';
    width: 90px;
    height: 90px;
    display: inline-flex;
    position: absolute;
    top: -45px;
    left: 50%;
    background-color: #FFFFFF;
    z-index: 2;
    transform: translateX(-50%);
    border-radius: 50%;

  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #FFFFFF;
    border-radius: 10px;
  }
}
.dayCube {
  height: 100%;
  box-sizing: border-box;
  min-height: 122px;
  &>.is-holiday {
    color: var(--color-confirm);
    font-weight: 700;
  }
  &.pass {
    // filter: contrast(.5);
    background-color: #DADADA88;
  }
  &.selected {
    // border: 2px solid var(--color-checked);
    background-color: var(--color-infobox);
    &.pass {
      filter: contrast(.7);
    }
  }
  &.disabled {
    background-color: #E5E5E5;
  }
  &>span:nth-child(1) {
    color: var(--color-checked);
    font-weight: 700;
    height: 45px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 36.7px;
    mask-image: url(/celender3.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-checked);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-checked);
  gap: 10px;
}
</style>
